export default __webpack_public_path__ + "static/media/catalog_step_img01.54615091.svg";